@if (pickType === pickTypes.Option) {
    @if (isHorsesPickAnyCast && pick.optionNames.length > 1) {
        <div class="betslip-result-succeeded-pick__option-name">
            @for (optionName of pick.optionNames; track optionName; let i = $index; let isLast = $last) {
                <span>
                    <span class="betslip-result-succeeded-pick__option-name_pos">{{ $any(sitecore.horseRacing.common)[i + 1] }}</span>
                    <span>
                        <strong>{{ optionName }}</strong>
                        @if (!isLast) {
                            ,
                        }
                    </span>
                </span>
            }
        </div>
    }
    @if (!isHorsesPickAnyCast) {
        <span class="betslip-result-succeeded-pick__option-name">{{ optionName }}</span>
    }
    <span class="betslip-result-succeeded-pick__odds" [ngClass]="{ 'priceboost-odds': isPriceBoost, 'teaser-odds': isTeaserBet }">
        @if (!isTeaserBet || !isLinear) {
            @if (!isPriceBoost) {
                @if (isStartingPrice) {
                    <span>{{ messages.startingPrice }}</span>
                }
                @if (!isStartingPrice) {
                    <bs-result-odds
                        [odds]="isTeaserBet ? pick.totalOdds : pick.odds"
                        [boostedOdds]="boostedOdds"
                        [oddsDisplayFormat]="oddsDisplayFormat" />
                }
            } @else {
                <span class="was-price was-price-betslip"> {{ wasPriceOdds }}</span>
                <ms-priceboost-count-signpost [count]="priceBoostOdds" [isLargeSignPost]="true" />
            }
        }
    </span>
    <span class="betslip-result-succeeded-pick__market-name">{{ optionMarketName }}</span>
    @if (isHorsesPick && isOptionBetBOGEligible) {
        <span class="betslip-result-succeeded-pick__bog">
            <ms-bog-help-badge />
        </span>
    }
    <span class="betslip-result-succeeded-pick__event-name">
        @if (isLive) {
            @if (isBadgeIndicator) {
                <span class="betslip-digital-pick__live-badge">{{ messages.live }}</span>
            } @else {
                <i class="live-icon live-red-dot"></i>
            }
        }
        @if (isHorsesPick || isHorsesPickAnyCast) {
            <span>{{ pick.clientPick?.eventDate | date: 'HH:mm' }}</span>
        }
        @if (isVirtual) {
            <span class="betslip-result-succeeded-pick__virtual-badge" [class]="'sports-' + pick.clientPick?.sportId"></span>
        }
        {{ pick.eventName }}
    </span>
    @if (marketLogoShow) {
        <ms-marketsubtype-logo
            class="betslip-result-succeeded-pick__marketsubtype-logo"
            [eventId]="pick.clientPick?.id?.fixtureId"
            [marketType]="pick.clientPick?.market?.marketType"
            [marketSubType]="pick.clientPick?.market?.marketSubType"
            [templateId]="pick.clientPick?.market?.templateId"
            [matchName]="pick.eventName"
            [sportId]="pick.clientPick?.sportId"
            [trackingLocation]="'bet receipt'"
            [tooltipAppendTo]="'bs-betslip'"
            [tooltipBoundaries]="'bs-betslip'"
            [tooltipPlacement]="NgxFloatUiPlacements.BOTTOMSTART" />
    }
    <ng-container *ngTemplateOutlet="summaryTemplate" />
}
@if (pickType === pickTypes.Participant) {
    <span class="betslip-result-succeeded-pick__option-name">{{ optionName }}</span>
    <span class="betslip-result-succeeded-pick__odds">{{ odds }}</span>
    <span class="betslip-result-succeeded-pick__market-name">{{ participantMarketName }}</span>
    @if (isBestOddsGuaranteedEligible) {
        <span class="betslip-result-succeeded-pick__bog">
            <ms-bog-help-badge />
        </span>
    }
    <span class="betslip-result-succeeded-pick__event-name">
        @if (!isGolfPick) {
            <span class="betslip-result-succeeded-pick__event-time">{{ pick.clientPick!.eventDate | date: 'HH:mm' }}</span>
        }
        {{ pick.eventName }}</span
    >
    @if (isEachWay && isGolfPick) {
        <span class="betslip-result-succeeded-pick__eachway-text">{{ eachWayText }}</span>
    }
    <ng-container *ngTemplateOutlet="summaryTemplate" />
}
@if (pickType === pickTypes.BetBuilder && !isEpcotBBMultisEnabled) {
    @if (isLinear) {
        <div class="bet-builder-linear">
            <ng-container *ngTemplateOutlet="buildABet" />
        </div>
    }
    <div class="betslip-result-succeeded-pick__option-name">
        @for (leg of getLegs(); track leg) {
            <div class="bet-builder-market-leg">
                <div class="bet-builder-circle-overlay">
                    <div class="bet-builder-circle theme-radio-off"></div>
                </div>
                <span class="bet-builder-leg">{{ leg }}</span>
            </div>
        }
    </div>
    <span class="betslip-result-succeeded-pick__odds">{{ pick.odds | bsOddsFormatter: oddsDisplayFormat }}</span>
    @if (!isLinear) {
        <ng-container *ngTemplateOutlet="buildABet" />
    }
    <ng-container *ngTemplateOutlet="summaryTemplate" />
}

<ng-template #buildABet>
    <span class="betslip-result-succeeded-pick__market-name">{{ messages.betBuilderMarketName }}</span>
    <span class="betslip-result-succeeded-pick__event-name">
        @if (isLive) {
            @if (isBadgeIndicator) {
                <span class="betslip-digital-pick__live-badge">{{ messages.live }}</span>
            } @else {
                <i class="live-icon live-red-dot"></i>
            }
        }
        {{ pick.eventName }}</span
    >
</ng-template>

@if (pickType === pickTypes.BetBuilder && isEpcotBBMultisEnabled) {
    <div class="combo-bet-pick-header__content">
        @if (isSgpBadgeInTitleEnabled) {
            <ms-sgp-badge />
        } @else {
            <span class="combo-bet-pick-header__title">{{ headerTitle }}</span>
            <div class="dot"></div>
        }
        <span class="combo-bet-pick-header__subtitle"> {{ headerSubTitle }}</span>
    </div>
    <span class="betslip-result-succeeded-pick__odds">{{ pick.odds | bsOddsFormatter: oddsDisplayFormat }}</span>
    <span class="combo-bet-betbuilder-pick__event-name">
        @if (isLive) {
            @if (isBadgeIndicator) {
                <span class="betslip-digital-pick__live-badge">{{ messages.live }}</span>
            } @else {
                <i class="live-icon live-red-dot"></i>
            }
        }
        {{ pick.eventName }}</span
    >
    <div class="betslip-result-succeeded-pick__option-name-bb">
        @for (leg of getLegs(); track leg) {
            <div class="bet-builder-market-leg">
                <div class="bet-builder-circle-overlay">
                    <div class="bet-builder-circle theme-radio-off"></div>
                </div>
                <span class="bet-builder-leg">{{ leg }}</span>
            </div>
        }
    </div>
    <ng-container *ngTemplateOutlet="summaryTemplate" />
}

<ng-template #summaryTemplate>
    @if (isSummaryVisible) {
        <div class="stake-info">
            @if (summary.betType === betSlipType.Single) {
                @if (isMultiplierVisible) {
                    <span class="betslip-result-succeeded-pick__each-way-multiplier">{{ multiplierValue }}</span>
                }
                <span class="betslip-result-succeeded-pick__stake">{{ stakeValue | bsCurrency: true }}</span>
            }
        </div>
        @if (summary.betType === betSlipType.Single) {
            <span class="betslip-result-succeeded-pick__possible-winnings">
                {{ summary.possibleWinnings.title }}
                @if (summary.possibleWinnings.value.equals(0)) {
                    {{ null | bsCurrency: true }}
                }
                @if (summary.possibleWinnings.value.greaterThan(0)) {
                    <span class="betslip-result-succeeded-pick__possible-winnings__value">
                        {{ summary.possibleWinnings.value | bsCurrency: true }}
                    </span>
                }
            </span>
        }
        @if (tokenPayoutSummary) {
            <bs-token-payout-summary class="betslip-result-succeeded-pick__token-payout-summary" [tokenPayoutSummary]="tokenPayoutSummary" />
        }
    }
</ng-template>

@if (summary.betType === betSlipType.Single && isLinear && summary.possibleWinningsGross && stakeValue) {
    <div class="betslip-result-succeeded-pick__total">
        <bs-digital-linear-result-bet-returns
            [stake]="stakeValue"
            [stakeMultiplier]="isMultiplierVisible ? multiplierValue : undefined"
            [possibleWinningsNet]="summary.possibleWinnings.value"
            [possibleWinningsGross]="summary.possibleWinningsGross"
            [rewardTokenInfo]="summary.rewardTokenInfo"
            [boostedValue]="summary.possibleWinnings.boostedValue" />
    </div>
}
